import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute } from '@angular/router';
import { CustomerOverViewService } from '../../customer-overview.service';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { Customer, SepaMandate, SidebarOptions } from '~core/models';
import { BankService, CustomerService, NavigationService, ScreenSizeService } from '~core/services';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { SidebarService } from '~core/components/sidebar/sidebar.service';
import { TooltipTranslationService } from '~shared/translations';

/**
 * This component is the page that views only the sepa mandates of the bank account
 */
@UntilDestroy()
@Component({
  selector: 'app-sepa-mandates-page',
  templateUrl: './sepa-mandates-page.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class SepaMandatesPageComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  public sepaMandates: Array<SepaMandate> = [];
  public customer: Customer;
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];

  constructor(
    public customerOverviewService: CustomerOverViewService,
    public customerService: CustomerService,
    public sidebarService: SidebarService,
    public navigationService: NavigationService,
    private bankService: BankService,
    private route: ActivatedRoute,
    public buttonsTranslations: ButtonsTranslations,
    public tooltipTranslations: TooltipTranslationService,
    public tablesTranslations: TablesTranslations,
    private screenSizeService: ScreenSizeService,

  ) {
    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }
    this.navigationService.setCurrentPage('sepaMandates');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'customerProfile']);
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe(customer => this.customer = customer);
    this.bankService.castSepaMandateList.pipe(untilDestroyed(this))
      .subscribe(sepaMandates => this.sepaMandates = sepaMandates);
    this.columns.push(
      this.tablesTranslations.i18nReference, this.tablesTranslations.i18nLastExecution, this.tablesTranslations.i18nType,
      this.tablesTranslations.i18nStatus, this.tablesTranslations.i18nSignaturePlace, this.tablesTranslations.i18nSignatureDate);
    this.keys.push(['referenceNumber', 'lastExecutionDate', 'type', 'status', 'signaturePlace', 'signatureDate']);
  }

  public ngOnInit(): void {
    this.route.params.pipe(untilDestroyed(this)).subscribe(params => {
      if (!this.sepaMandates) {
        this.bankService.getSepaMandates(params['id']).pipe(untilDestroyed(this))
          .subscribe((res: Array<SepaMandate>) => {
            this.sepaMandates = res;
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    });
  }

  public ngOnDestroy(): void {
    this.customerOverviewService.toggleAllModal(false);
  }

}
